import { useEffect, useState } from "react";
import React from "react";
import { useNavigate, Link } from "react-router-dom";
import SideBarData from "./SideBarData.js";
import ProfileIcon from "../../Assets/legallens-logo.png"
import {GoSignIn} from "react-icons/go"
import { useDispatch, useSelector } from "react-redux";
import "./Navbar.css";
import axios from "axios";
import {
    STATE_INITIALIZED,
    LOAD_USER_SUCCESS,
    LOGOUT_SUCCESS,
  } from "../../Constants/userConstants.js";

import {
    TC_INVALIDATED,
    TC_UNSAVED_CLEAR,
} from "../../Constants/tcConstants.js";

import {
    C_INVALIDATED,
} from "../../Constants/cConstants.js";

const NavBar = () => {

    const { user, isAuth, reload } = useSelector((state) => state.user);
    const { tc } = useSelector((state) => state.tc);
    const [profilePic, setProfilePic] = useState(ProfileIcon);
    const [userName, setUserName] = useState("Guest");
    // const [sidebarData, setsidebarData] = useState(SideBarData.pages);
    const sidebarData = SideBarData.pages;

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        setUserName((isAuth && user && user.username) ? user.username : "Guest");
        setProfilePic((isAuth && user && user.profilePic && user.profilePic.url) ? user.profilePic.url : ProfileIcon);
        if (reload){
            axios({
                method: 'get',
                url: 'api/v1/users/me',
                baseURL: '/'    
            })
            // axios.get('api/v1/users/me')
            .then((response) => {
                if (response.data.user){
                    dispatch({ type: LOAD_USER_SUCCESS, payload: response.data.user });
                }

                dispatch({ type: STATE_INITIALIZED});
            })
            .catch(function (error){
                dispatch({ type: STATE_INITIALIZED});
            });
        }
    }, [isAuth, user, reload, dispatch ]);
    //dispatch not necessary to add, but we'll do it.

    useEffect(() => {
        if (isAuth && user && user.preferences) {
          const textSize = user.preferences.textSize;
    
          switch (textSize) {
            case 0: // Small
                document.documentElement.style.setProperty('--font-size-header', '1.5vw');
                document.documentElement.style.setProperty('--font-size-label', '14px');
                document.documentElement.style.setProperty('--font-size-input', '14px');
                document.documentElement.style.setProperty('--font-size-button', '0.8vw');
                document.documentElement.style.setProperty('--nav-width', '10vw');
                document.documentElement.style.setProperty('--nextToPic', '3.5vw');
                break;
            case 1: // Medium (default)
                document.documentElement.style.setProperty('--font-size-header', '2vw');
                document.documentElement.style.setProperty('--font-size-label', '16px');
                document.documentElement.style.setProperty('--font-size-input', '16px');
                document.documentElement.style.setProperty('--font-size-button', '1vw');
                document.documentElement.style.setProperty('--nav-width', '15vw');
                document.documentElement.style.setProperty('--nextToPic', '8.5vw');
                break;
            case 2: // Large
                document.documentElement.style.setProperty('--font-size-header', '3vw');
                document.documentElement.style.setProperty('--font-size-label', '24px');
                document.documentElement.style.setProperty('--font-size-input', '24px');
                document.documentElement.style.setProperty('--font-size-button', '2vw');
                document.documentElement.style.setProperty('--nav-width', '25vw');
                document.documentElement.style.setProperty('--nextToPic', '18.5vw');
                break;
            default:
              break;
          }
        } else if (!isAuth) { 
            document.documentElement.style.setProperty('--font-size-header', '2vw');
            document.documentElement.style.setProperty('--font-size-label', '16px');
            document.documentElement.style.setProperty('--font-size-input', '16px');
            document.documentElement.style.setProperty('--font-size-button', '1vw');
            document.documentElement.style.setProperty('--nav-width', '15vw');
            document.documentElement.style.setProperty('--nextToPic', '8.5vw');
          }
        }, [user, isAuth]);

    // const handleSignIn = () => {
    //     console.log("Sign in");
    // }

    const handleLogout = async () => {
        axios({
            method: 'get',
            url: 'api/v1/users/logout',
            baseURL: '/'    
        })
            // .get('api/v1/users/logout')
            .then((response) => {
                dispatch({ type: LOGOUT_SUCCESS});
                dispatch({ type: TC_INVALIDATED});
                dispatch({ type: TC_UNSAVED_CLEAR});
                dispatch({ type: C_INVALIDATED});
                navigate('/');
            })
            .catch(function (error){
                if (error.response) {
                    //request made and server rejected it
                    console.log(error.response.status);
                    console.log(error.response.data);
                    console.log(error.response.headers);
                  } else if (error.request){
                    //request made but no response received
                    console.log("No response from server");
                  } else {
                    //some other problem while setting up the request
                    console.log("Error setting up request");
                  }
            });
    }
        
	return (
        <div className="navbarContainer">
            <div className="navbar">
                <div className="userSidebar">
                    <img className="profilePic" src={profilePic} alt="Logo"/>
                    <div className="userAndSignIn">
                        <li className="usernameDisplay nextToProfilePic">{userName}</li>
                        {(!isAuth) && <div>
                            <Link to={"/signin"} key={"userSignIn"}>
                                <li className="signInBtnSideBar nextToProfilePic">
                                        <GoSignIn/>
                                        <span>Sign In</span>   
                                </li>
                            </Link>
                            </div>
                        }
                        {(isAuth) && <div>
                            <li className="logout-button nextToProfilePic" onClick={handleLogout}>
                                <span>Log Out</span>   
                            </li>
                            </div>
                        }
                    </div>
                </div>
                <nav>
                    {sidebarData.map((page) =>{
                        if (page.needsAuth) {
                            return (
                                (isAuth) && <Link to={page.path} key={page.id}>
                                    <li className="sidebarItems" id={page.id}>
                                        <page.icon/>
                                        <span>{page.title}</span>   
                                    </li>
                                </Link>
                            );
                        }
                        if (page.needTC && tc) {
                            return (
                                <Link to={page.path} key={page.id}>
                                <li className="sidebarItems">
                                        <page.icon/>
                                        <span>{page.title}</span>   
                                </li>
                                </Link>
                            )
                        }
                        return (
                            <Link to={page.path} key={page.id}>
                                <li className="sidebarItems" id={page.id}>
                                        <page.icon/>
                                        <span>{page.title}</span>   
                                </li>
                            </Link>
                        )
                    })}
                </nav>
            </div>
        </div>
	)
}

export default NavBar;